import React, { useState } from 'react';

const AccessCodeAuth = ({ onAuthSuccess }) => {
  const [accessCode, setAccessCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await fetch('https://schoolofservice.co.za/backend/validate_access_code.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ code: accessCode }),
      });

      const data = await response.json();
      
      if (data.status === 'success') {
        setSuccess('Access granted! Redirecting to RBM Evaluator...');
        // Store the access code in session storage for this session
        sessionStorage.setItem('rbmAccessCode', accessCode);
        // Call the success callback after a short delay
        setTimeout(() => {
          onAuthSuccess();
        }, 1500);
      } else {
        setError(data.message || 'Invalid access code');
      }
    } catch (error) {
      setError('Network error. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container py-5 d-flex justify-content-center align-items-center min-vh-100" style={{ background: '#f8fafc' }}>
      <div className="card shadow-lg p-5" style={{ maxWidth: 500, background: '#fff', borderRadius: '2rem' }}>
        <div className="text-center mb-4">
          <span className="me-3" style={{ fontSize: '3rem', color: '#0d6efd' }}>
            <i className="bi bi-shield-lock-fill"></i>
          </span>
          <h1 className="mb-0" style={{ fontWeight: 800, letterSpacing: 1, fontSize: '2.2rem' }}>
            RBM Evaluator Access
          </h1>
        </div>
        
        <div className="alert alert-info mb-4" style={{ fontSize: '1.1rem' }}>
          <strong>Access Required:</strong> Please enter your access code to use the RBM & M&E Tool for CBOs.
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="accessCode" className="form-label fw-bold" style={{ fontSize: '1.2rem' }}>
              Access Code
            </label>
            <input
              type="text"
              className="form-control form-control-lg text-center"
              id="accessCode"
              value={accessCode}
              onChange={(e) => setAccessCode(e.target.value.toUpperCase())}
              placeholder="Enter 8-character code"
              maxLength="8"
              style={{ 
                fontSize: '1.5rem', 
                letterSpacing: '0.5rem',
                fontWeight: 'bold',
                textTransform: 'uppercase'
              }}
              required
            />
            <div className="form-text text-center mt-2">
              Enter the 8-character access code provided by your administrator
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg w-100 fw-bold fs-4 py-3"
            disabled={isLoading || !accessCode.trim()}
            style={{ letterSpacing: 1 }}
          >
            {isLoading ? 'Validating...' : 'Access RBM Evaluator'}
          </button>
        </form>

        {error && (
          <div className="alert alert-danger mt-4" style={{ fontSize: '1.1rem' }}>
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            {error}
          </div>
        )}

        {success && (
          <div className="alert alert-success mt-4" style={{ fontSize: '1.1rem' }}>
            <i className="bi bi-check-circle-fill me-2"></i>
            {success}
          </div>
        )}

        <div className="text-center mt-4">
          <small className="text-muted">
            Don't have an access code? Contact your administrator.
          </small>
        </div>
      </div>
    </div>
  );
};

export default AccessCodeAuth; 